import React from "react";
import { motion } from "framer-motion";

export function SectionHeading({ eyebrow, title, copy, align = "left", testId = "section-heading" }) {
  return (
    <motion.div
      initial={{ opacity: 0.96, y: 12 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.35 }}
      transition={{ duration: 0.35 }}
      className={`mb-12 ${align === "center" ? "mx-auto max-w-3xl text-center" : "max-w-3xl"}`}
      data-testid={testId}
    >
      {eyebrow && <p data-testid={`${testId}-eyebrow`} className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] text-[#C84B31]">{eyebrow}</p>}
      <h2 data-testid={`${testId}-title`} className="text-4xl font-light tracking-tight text-[#2C2C2A] sm:text-5xl">{title}</h2>
      {copy && <p data-testid={`${testId}-copy`} className="mt-5 text-base leading-relaxed text-[#6B6B66] md:text-lg">{copy}</p>}
    </motion.div>
  );
}